// Card para estatísticas secundárias (Erros, Transações, Throughput)

import { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface StatsCardProps {
  title: string;
  value: number | string;
  icon: ReactNode;
  description?: string;
  variant?: 'default' | 'danger' | 'success';
  isLoading?: boolean;
  onClick?: () => void;
}

export function StatsCard({ 
  title, 
  value, 
  icon, 
  description, 
  variant = 'default',
  isLoading,
  onClick,
}: StatsCardProps) {
  const variantStyles = {
    default: 'bg-card',
    danger: 'bg-red-500/5 border-red-500/20',
    success: 'bg-green-500/5 border-green-500/20',
  };

  const valueStyles = {
    default: 'text-foreground',
    danger: 'text-red-600',
    success: 'text-green-600',
  };

  if (isLoading) {
    return (
      <Card className={variantStyles[variant]}>
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div>
              <Skeleton className="h-4 w-16 mb-2" />
              <Skeleton className="h-8 w-12" />
            </div>
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card 
      className={`${variantStyles[variant]} ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
      onClick={onClick}
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">{title}</p>
            <p className={`text-2xl font-bold ${valueStyles[variant]}`}>
              {typeof value === 'number' ? value.toLocaleString('pt-BR') : value}
            </p>
            {description && (
              <p className="text-xs text-muted-foreground mt-1">{description}</p>
            )}
          </div>
          <div className={`p-2.5 rounded-full ${variant === 'danger' ? 'bg-red-500/10' : variant === 'success' ? 'bg-green-500/10' : 'bg-muted'}`}>
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
